import { api } from './api';
import { IStringKey, PlatformCode } from 'type/common';

export interface IFilter extends IStringKey {
	content_type?: string;
	account_type?: 'normal' | 'brand' | 'all';
	followers?: string;
	categories?: string;
	estimate_gender?: 'F,M' | 'F' | 'M' | 'all';
	estimate_age?: string;
	page_size?: string;
	order_by?: string;
	order?: string;
	campaign_experience?: string;
	platform_code: PlatformCode;
}

export const match_apis = {
	setFilter: (platform: 'ig' | 'yt' | 'nb' | 'tt', data: IFilter) =>
		api.post(`discover/influencer/user-filter/${platform}`, data),
	getFilter: async (platform: PlatformCode) => {
		const data = await api.get(`discover/influencer/user-filter/${platform}`);

		return data.data.result;
	},
	getMatchList: async (params: IFilter) => {
		const data = await api.get(`discover/influencer`, {
			params: {
				...params,
			},
		});

		return data.data.result;
	},
	getPreview: async (platform: PlatformCode, platform_pk: string) => {
		const data = await api.get(`influencer/${platform}/${platform_pk}/contents/list`);

		return data.data.result;
	},
};
